module.exports = __webpack_public_path__ + "img/20180120_5.abe0ed86.jpeg";